"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _job = require("@/api/job/job");
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TimeExpressionValidator',
  // 数据传递
  props: ['timeExpressionType', 'timeExpression'],
  // eslint-disable-line
  data: function data() {
    return {
      nextNTriggerTime: [],
      listQuery: {
        timeExpressionType: undefined,
        timeExpression: undefined
      }
    };
  },
  mounted: function mounted() {
    this.checkTimeExpression();
  },
  methods: {
    checkTimeExpression: function checkTimeExpression() {
      var _this = this;
      this.listQuery.timeExpressionType = this.timeExpressionType;
      this.listQuery.timeExpression = this.timeExpression;
      (0, _job.queryTimeExpression)(this.listQuery).then(function (response) {
        _this.nextNTriggerTime = response.data.data;
      });
    }
  }
};